import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibFieldShape, userIdentityShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import Heading from '@bibliocommons/heading';

import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import MetadataDisplay from 'app/components/bibs/shared/MetadataDisplay';
import { FullDetails } from './FullDetails';

import './Details.scss';

export default class Details extends React.PureComponent {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  renderFullDetailsLink = () => {
    const { trackFieldItemClick } = this.props;

    return (
      <div className="cp-full-details-link">
        <ChevronLink
          href="#full-details-overlay"
          dataKey="full-details-link"
          handleClick={this.handleOpen}
          preventDefault
        >
          <span aria-hidden>
            <FormattedMessage id="full_details" />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="full_details_open" />
          </ScreenReaderMessage>
        </ChevronLink>

        <FullScreenOverlayContainer
          open={this.state.open}
          handleClose={this.handleClose}
          overlayKey="bib-details-full-screen-overlay"
          dataKey="bib-details-full-screen-overlay"
        >
          {this.state.open && (
            <FullDetails catalogBib={this.props.catalogBib} trackFieldItemClick={trackFieldItemClick} />
          )}
        </FullScreenOverlayContainer>
      </div>
    );
  };

  renderLinkToMarcPage() {
    if (!this.props.currentUser || !this.props.currentUser.get('staff')) return null;

    return (
      <ChevronLink
        href={`/v2/record/${this.props.catalogBib.get('metadataId')}/originalrecord`}
        className="original-record-link"
        dataKey="original-record-link"
      >
        <FormattedMessage id="original_record" />
      </ChevronLink>
    );
  }

  render() {
    const { fields } = this.props;

    return (
      <div className="cp-bib-details">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="bib_metadata_category_about" />
        </Heading>
        {fields && <MetadataDisplay fields={fields.get('items')} compact handleClick={() => null} />}
        {this.renderFullDetailsLink()}
        {this.renderLinkToMarcPage()}
      </div>
    );
  }
}

Details.propTypes = {
  fields: ImmutablePropTypes.mapContains({
    category: PropTypes.string.isRequired,
    items: ImmutablePropTypes.listOf(bibFieldShape).isRequired
  }),
  currentUser: userIdentityShape,
  catalogBib: catalogBibShape.isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};
